'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_1ba53a2f = {"global-search":"GlobalSearch_module_globalSearch__ab01658a"};
require("../../../assets/cjs/components/Table/src/GlobalSearch~waAvYfcL.css");

exports.default = modules_1ba53a2f;
//# sourceMappingURL=GlobalSearch.module.less.js.map
